export default [
  {
    name: "environmentMapTexture",
    type: "cubeTexture",
    path: [
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/px.jpg",
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/nx.jpg",
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/py.jpg",
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/ny.jpg",
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/pz.jpg",
      "/26-code-structuring-for-bigger-projects/textures/environmentMap/nz.jpg",
    ],
  },
  {
    name: "grassColorTexture",
    type: "texture",
    path: "/26-code-structuring-for-bigger-projects/textures/dirt/color.jpg",
  },
  {
    name: "grassNormalTexture",
    type: "texture",
    path: "/26-code-structuring-for-bigger-projects/textures/dirt/normal.jpg",
  },
  {
    name: "foxModel",
    type: "gltfModel",
    path: "/26-code-structuring-for-bigger-projects/models/Fox/glTF/Fox.gltf",
  }
]